import { Injectable, ElementRef } from '@angular/core';
import { chain, get, forEach, assign } from 'lodash';
import { StoreService } from '../store';
const SCROLL_DURATION = 800;

@Injectable()
export class AccordionHelperService {
	elemProgressAccordion: any;
	newScrollTop: any;
	sections: section[];

	constructor(private storeService: StoreService) {}

	getfilteredSections(progressMeter: progressMeter) {
		if (!progressMeter || !progressMeter.visible) {
			return [];
		}

		this.sections = [];
		forEach(progressMeter.sections, (section) =>
			section.states
				? this.sections.push(section) && forEach(section.states, (state) => this.sections.push(state))
				: this.sections.push(section)
		);

		return chain(this.sections)
			.map((section) => [section])
			.flatten()
			.filter((section) => section.completed && section.AccordionDisplay == null)
			.value();
	}

	//calcHeight(sections: section[]) {
	//// TODO: use $compile and progress-accordion instead of duplicating template
	//this.elemProgressAccordion = document.getElementsByTagName('progress-accordion')[0];
	////this.elemProgressAccordion = el.nativeElement.document.querySelector('progress-accordion');

	//let tempContainer = document.createElement('div');
	//let tempMeasureContainer = document.createElement('div');

	//forEach(sections, (section) => {
	//  const tempElement = document.createElement('div');
	//  //remove auto stage here?
	//  tempElement.className = 'completed-section-container';
	//  tempElement.innerHTML = `
	//        <div class="completed-section clearfix">
	//          <div class="title">${ section.title}</div>
	//          <div class="subtitle">${ this.getSectionSubtitle(section)}</div>

	//          <button class="editpencil"><span></span> <i class=""></i>
	//          </button>
	//        </div>
	//      `;

	//  tempMeasureContainer.appendChild(tempElement);
	//});

	//assign(tempContainer.style, { overflow: 'hidden', height: 0 });
	//tempContainer.appendChild(tempMeasureContainer);

	//this.elemProgressAccordion.appendChild(tempContainer);

	//const accordionHeight = tempMeasureContainer.offsetHeight;

	//this.elemProgressAccordion.removeChild(tempContainer);

	//tempContainer = undefined;
	//tempMeasureContainer = undefined;

	//this.newScrollTop = accordionHeight;
	//return accordionHeight;
	//}

	//scrollToEnd({ animated = false }) {
	//if (animated) {
	//  zenscroll.setup(SCROLL_DURATION);
	//  zenscroll.toY(this.newScrollTop);
	//}
	//else {
	//  document.body.scrollTop = this.newScrollTop != 0 ? this.newScrollTop : 57;
	//}
	//}

	getSectionSubtitle(section: section) {
		return this.storeService.getDynamicContent(`StageSummary.${section.name}`);
	}
}
